import { render, staticRenderFns } from "./MindoCard.vue?vue&type=template&id=0fbf080c&"
import script from "./MindoCard.vue?vue&type=script&lang=js&"
export * from "./MindoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports